import { render, staticRenderFns } from "./SelectSalePersonModal.vue?vue&type=template&id=61b73f44&"
import script from "./SelectSalePersonModal.vue?vue&type=script&lang=js&"
export * from "./SelectSalePersonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports